import React from 'react'
import { cn } from '@/utils'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export interface InfoCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  value: string | number
  icon?: React.ReactNode
  trend?: {
    value: number
    isPositive: boolean
  }
  isLoading?: boolean
}

const InfoCard = React.forwardRef<HTMLDivElement, InfoCardProps>(
  ({ className, title, value, icon, trend, isLoading, ...props }, ref) => {
    return (
      <Card
        ref={ref}
        variant="default"
        className={cn('relative overflow-hidden', className)}
        {...props}
      >
        <CardContent>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                {title}
              </p>
              {isLoading ? (
                <Skeleton className="mt-2 h-7 w-24" />
              ) : (
                <h4 className="mt-2 text-2xl font-bold text-gray-900 dark:text-gray-100">{value}</h4>
              )}
            </div>
            {icon && (
              <div className="rounded-full bg-gray-100 dark:bg-gray-800 p-2">
                {icon}
              </div>
            )}
          </div>

          {trend && !isLoading && (
            <div className="mt-4 flex items-center space-x-2">
              <span
                className={cn(
                  'text-sm font-medium',
                  trend.isPositive ? 'text-green-500' : 'text-red-500'
                )}
              >
                {trend.isPositive ? '+' : '-'}{Math.abs(trend.value)}%
              </span>
              <span className="text-sm text-gray-600 dark:text-gray-400">
                vs last period
              </span>
            </div>
          )}
        </CardContent>
      </Card>
    )
  }
)
InfoCard.displayName = 'InfoCard'

export default InfoCard 